// extracted by mini-css-extract-plugin
export var why = "why-module--why--0b91f";
export var why__item = "why-module--why__item--6c77b";
export var why__list = "why-module--why__list--018a0";